export default "__VITE_ASSET__DePzkuV7__"